const statusTypeCategories = {
    redo: "REDO",
    stuck: "STUCK"
}

export default statusTypeCategories
